import React from "react";
import TitleSection from "src/components/TitleSection/TitleSection";
import { BiSolidDollarCircle } from "react-icons/bi";
import { LuAlarmClock } from "react-icons/lu";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";

const TitanPeriods = ({ qualifyingPeriods, payoutPeriods, highlightColor }) => {
  if (!qualifyingPeriods || !payoutPeriods) {
    return null;
  }

  return (
    <PeriodsRow $highlightColor={highlightColor} className="periods mt-5 pb-3">
      <Col>
        <LuAlarmClock />
        <TitleSection
          as="h3"
          title={qualifyingPeriods.title}
          text={qualifyingPeriods.text}
          className="py-0"
          borderColor={highlightColor}
        />
      </Col>
      <Col>
        <BiSolidDollarCircle />
        <TitleSection
          as="h3"
          title={payoutPeriods.title}
          text={payoutPeriods.text}
          className="py-0"
          borderColor={highlightColor}
        />
      </Col>
    </PeriodsRow>
  );
};

const PeriodsRow = styled(Row)`
  text-align: center;

  svg {
    margin: 20px 0 10px;
    color: ${(props) => props.$highlightColor};
    font-size: 40px;
  }
`;

export default TitanPeriods;
